export const PSEUDO_MIN_LENGTH = 3;
export const PSEUDO_MAX_LENGTH = 24;
export const PSEUDO_PATTERN = /^[a-zA-Z0-9_]+$/;

export function normalizePseudo(value) {
  return String(value ?? '').trim().replace(/^@+/, '');
}

export function validatePseudo(value) {
  const pseudo = normalizePseudo(value);
  if (pseudo.length < PSEUDO_MIN_LENGTH) {
    return { pseudo, error: `Le pseudo doit faire au moins ${PSEUDO_MIN_LENGTH} caracteres.` };
  }
  if (pseudo.length > PSEUDO_MAX_LENGTH) {
    return { pseudo, error: `Le pseudo doit faire ${PSEUDO_MAX_LENGTH} caracteres maximum.` };
  }
  if (!PSEUDO_PATTERN.test(pseudo)) {
    return { pseudo, error: 'Utilise seulement lettres, chiffres et underscore.' };
  }
  return { pseudo, error: null };
}
